import { i18n } from "@/locale";
import Settings from "@/settings.js";

const DEFAULT_TITLE = "User Center";

function translateMetaValue(key, fallback) {
    if (!key) return fallback || "";
    return i18n.global.t(key);
}

export function getRouteTitle(route) {
    return translateMetaValue(route?.meta?.titleKey, route?.meta?.title) || DEFAULT_TITLE;
}

export function getRouteDesc(route) {
    return translateMetaValue(route?.meta?.descKey, route?.meta?.desc);
}

export function getRouteMeta(route) {
    return {
        ...route.meta,
        title: getRouteTitle(route),
        desc: getRouteDesc(route),
    };
}

export function updateDocumentTitle(route) {
    document.title = `${getRouteTitle(route)} · ${Settings.TitleSuffix}`;
}
